import { APIClient } from '@frontend/api-utils';

export class LabelTemplatePlaceholderClient extends APIClient {
    public static readonly endpoint = '/label-api/v1';

    public static async fetchPlaceholders(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/placeholders`);
        return await this.handleResponse<string[]>(response);
    }
}
